import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import localForage from 'localforage'
import locationTracking from 'store/middlewares/locationTracking'
import waitForSagas from 'store/middlewares/waitForSagas'
import { connectedRouter, routeMiddleware } from 'router'
import SystemActions from 'store/redux/system'

import Config from 'config'

const persistConfig = {
    key: Config.reduxPersist.prefix,
    whitelist: Config.reduxPersist.whitelist,
    storage: localForage
}

export default (rootReducer, rootSaga) => {
    const persistedReducer = persistReducer(persistConfig, connectedRouter(rootReducer))
    // Redux Configuration
    const middleware = []
    const enhancers = []
    // waitForSagas Middleware
    middleware.push(waitForSagas)
    // locationTracking Middleware
    middleware.push(locationTracking)
    // Middleware for navigating
    middleware.push(routeMiddleware)
    // Saga Middleware
    const sagaMonitor = Config.useReactotron ? console.tron.createSagaMonitor() : null
    const sagaMiddleware = createSagaMiddleware({ sagaMonitor })
    middleware.push(sagaMiddleware)
    // Assemble Middleware
    enhancers.push(applyMiddleware(...middleware))
    // If Reactotron is enabled (default for dev), we'll create the store through Reactotron
    const createAppropriateStore = Config.useReactotron ? console.tron.createStore : createStore
    const store = createAppropriateStore(persistedReducer, compose(...enhancers))
    // Create Store
    // Kick off root saga
    store.sagaTask = sagaMiddleware.run(rootSaga)
    // Init Store with default data
    const startup = () => store.dispatch(SystemActions.startup())
    const persistor = persistStore(store, null, startup)
    return { store, persistor }
}



// WEBPACK FOOTER //
// src/store/configureStore.js